document.addEventListener("DOMContentLoaded", function () {
  const FacetTitle = {
    inputName: "filter.v.title.gte",

    elements: {
      container: null,
    },

    methods: {
      updateCount: (count = 0) => {
        const countEls = document.querySelectorAll(".title__visible--count");
        countEls.forEach((el) => {
          el.innerHTML = `${count} found`;
        });
        FacetTitle.methods.showNoContentUIIfEmpty(count);
      },

      showNoContentUIIfEmpty: (count) => {
        if (count == 0) {
          FacetTitle.elements.container.after(FacetTitle.methods.createNoContentUI());
        } else {
          const noContentUI = FacetTitle.elements.container.nextSiblingElement;
          if (noContentUI) {
            noContentUI.remove();
          }
        }
      },

      resetContainer: () => {
        const containerChildren = Object.values(
          FacetTitle.elements.container.children,
        );
        containerChildren.forEach((card) => {
          card.style.display = "block";
        });
        FacetTitle.methods.updateCount(containerChildren.length);
      },

      createNoContentUI: () => {
        const h2 = document.createElement("h2");
        h2.classList.add("title-wrapper");
        h2.classList.add("center");
        h2.innerHTML = `
            <h2 class="title title--primary">
              No products found<br>
              Use fewer filters or <a class="underlined-link link" href="/collections/all-products">remove all</a>
            </h2>             
          `;
        return h2;
      },

      onPageRender: (e) => {
        const { target } = e;
        if (!target) return;

        const { activeElement } = target;
        if (
          !activeElement ||
          !(activeElement instanceof HTMLInputElement) ||
          activeElement.getAttribute("name") !== FacetTitle.inputName
        ) {
          FacetTitle.methods.resetContainer();
          return;
        }

        // Active element value
        const activeElementValue = activeElement.value?.trim().toLowerCase();

        if (!FacetTitle.elements?.container?.children) {
          throw new Error("Facet title: Container must be defined");
        }

        let count = 0;

        // Hide/show children of FacetTitle.elements.container
        Object.values(FacetTitle.elements.container.children).forEach(
          (card) => {
            const titleEl = card.querySelector(".title");
            const titleText = titleEl.innerText.trim().toLowerCase();

            const foundCard = document.querySelector(`#${card.id}`);

            if (!titleText.includes(activeElementValue)) {
              foundCard.style.display = "none";
            } else {
              foundCard.style.display = "block";
              count++;
            }
          },
        );

        FacetTitle.methods.updateCount(count);
      },
    },

    events: () => {
      document.addEventListener(
        "facets:render-page",
        FacetTitle.methods.onPageRender,
      );
    },

    init: () => {
      const containerIdHolder = document.querySelector(
        "[data-facet-title-container-id]",
      );

      FacetTitle.elements.container = document.querySelector(
        `#${containerIdHolder.dataset.facetTitleContainerId}`,
      );

      FacetTitle.methods.updateCount(
        FacetTitle.elements?.container?.children?.length ?? 0,
      );

      FacetTitle.events();
    },
  };

  FacetTitle.init();
});
